const Icon14CheckCircle = () => {
	return (
		<svg
			width="15"
			height="14"
			viewBox="0 0 15 14"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_4620_95341)">
				<path
					d="M10.5 5L6.3 9L4.5 7.28587"
					stroke="#242424"
					strokeWidth="1.5"
					strokeLinecap="square"
					strokeLinejoin="round"
				/>
			</g>
			<rect
				x="1.2"
				y="0.7"
				width="12.6"
				height="12.6"
				rx="6.3"
				stroke="#242424"
				strokeWidth="1.4"
			/>
			<defs>
				<clipPath id="clip0_4620_95341">
					<rect x="0.5" width="14" height="14" rx="7" fill="white" />
				</clipPath>
			</defs>
		</svg>
	)
}

export default Icon14CheckCircle
